export var ModuleNameType;
(function (ModuleNameType) {
    ModuleNameType["inventory_accounting"] = "inventory_accounting";
    ModuleNameType["ordering_devices"] = "ordering_devices";
    ModuleNameType["einvoices"] = "einvoices";
    ModuleNameType["kds"] = "kds";
    ModuleNameType["product_buttons"] = "product_buttons";
    ModuleNameType["product_ingredients"] = "product_ingredients";
    ModuleNameType["pricelists"] = "pricelists";
    ModuleNameType["qr_ordering"] = "qr_ordering";
    ModuleNameType["beach"] = "beach";
    ModuleNameType["beach_booking"] = "beach_booking";
    ModuleNameType["delivery"] = "delivery";
})(ModuleNameType || (ModuleNameType = {}));
//# sourceMappingURL=defAppStore.js.map